import type { SVGProps } from 'react';

interface GlitterSuccessTickProps extends SVGProps<SVGSVGElement> {}

export const GlitterSuccessTick = (props: GlitterSuccessTickProps) => {
	return (
		<svg
			width="41"
			height="40"
			viewBox="0 0 41 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<title>Glitter Success Tick</title>
			<circle cx="20.5" cy="20" r="17" fill="#BFE0CB" />
			<circle cx="20.5" cy="19.975" r="13" fill="#1E6B38" />
			<circle cx="21.5" cy="18.975" r="12" fill="#2B9950" />
			<path
				d="M27.8012 4.59546L29.0095 7.65915L32.0732 8.86745L29.0095 10.0757L27.8012 13.1394L26.5929 10.0757L23.5292 8.86745L26.5929 7.65915L27.8012 4.59546Z"
				fill="white"
			/>
			<path
				d="M32.0732 15.4741L32.9164 17.6031L35.0544 18.4427L32.9164 19.2823L32.0732 21.4113L31.23 19.2823L29.0919 18.4427L31.23 17.6031L32.0732 15.4741Z"
				fill="white"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M27.2499 14.6321C27.738 15.1203 27.738 15.9117 27.2498 16.3999L19.5121 24.1374C19.0239 24.6256 18.2325 24.6256 17.7444 24.1374L14.5971 20.9902C14.1089 20.5021 14.1089 19.7106 14.5971 19.2225C15.0852 18.7343 15.8767 18.7343 16.3648 19.2225L18.6282 21.4858L25.4821 14.6321C25.9703 14.1439 26.7617 14.144 27.2499 14.6321Z"
				fill="#EAF5EE"
			/>
		</svg>
	);
};

export default GlitterSuccessTick;
